import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import Editor from "../../components/Editing/Editor";
import { nameofFactory, hasWriteAccess } from "../../utils/utils";
import { EditActions, editActions } from "../../actions/editActions";
import DropdownField from "../../components/Editing/DropdownField";
import { getActionEnumOptions } from "../../utils/pdApiUtils";
import NumberField from "../../components/Editing/NumberField";
import Table from "../../components/Table/Table";
import { editedObjectIdSelector } from "../../reducers/editReducer";
import { Dimmer, Loader } from "semantic-ui-react";

type StateProps = {
  editedIoBoard: Api.IoBoard;
  storedIoBoard: Api.IoBoard;
  editedObjectId: string;
  pdApi: State.PdApi;
  ioConfig: State.IoConfig;
  columns: State.ColumnMap;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleModal: () => void;
};

const ioBoardFields = nameofFactory<Api.IoBoard>();

export type EditIoBoardProps = StateProps & DispatchProps & OwnProps;

export class EditIoBoard extends React.Component<EditIoBoardProps> {
        
  render(): JSX.Element {
    const { editedObjectId, editedIoBoard, storedIoBoard, activeUser, toggleModal, pdApi, columns } = this.props;
    const sideOptions = getActionEnumOptions(pdApi.sides);
    const isCopy = !editedObjectId && editedIoBoard.modelId;
    
    // Build standardBoard table for selection
    const standardBoardRows = this.props.ioConfig.standardBoards;
    const selectedColumns: State.Column[] = columns["Standard Boards"];
    const isNew = !storedIoBoard; 
    return (
      <>
        {" "}
        {this.props.ioConfig.localFetchingStatus === "Fetching Node Points" ? (
          <Dimmer active={true} inverted={true}>
            <Loader content={this.props.ioConfig.localFetchingStatus} />
          </Dimmer>
        ) : (
          <Editor
            itemName={"Io Board"}
            originalObject={storedIoBoard}
            editedObject={editedIoBoard}
            hasWritePermission={hasWriteAccess(activeUser, "Lift")}
            isValid={this.isAllFieldsValid()}
            cancel={this.props.editActions.cancelEditing}
            update={() => this.props.editActions.update("ioBoards" as Api.OptionsGrud)}
            create={() => this.props.editActions.add("ioBoards" as Api.OptionsGrud)}
            copy={() => this.props.editActions.startEditing({ ...editedIoBoard, id: undefined }, true)}
            remove={{ callback: toggleModal }}
          >
            {isNew ? (
              <>
                <h3>Select Standard board</h3>
                <Table
                  disablePagination={true}
                  rows={standardBoardRows}
                  columns={selectedColumns}
                  isHidingTextActive={false}
                  handleRowSelection={isCopy ? ()=>null :ioBoard =>
                    this.props.editActions.setEdited({ ...editedIoBoard, standard: ioBoard })
                  }
                  isRowSelected={row => row.id === editedIoBoard.standard.id}
                  pageSize={10000}
                  setHeight="600px"
                />
              </>
            ) : (
              <h3>
                {editedIoBoard.standard
                  ? `${editedIoBoard.standard.boardType.enumName} |${editedIoBoard.standard.revision}`
                  : ""}
              </h3>
            )}
            <NumberField
              id="parallelIdx"
              label="Parallel index"
              value={editedIoBoard.parallelIdx}
              isError={!this.isFieldValid(ioBoardFields("parallelIdx"))}
              onChange={val => this.props.editActions.setEdited({ ...editedIoBoard, parallelIdx: val })}
            />
            <div className="flex-row space-between">
              <DropdownField
                id="side"
                label="Side"
                value={editedIoBoard.side}
                options={sideOptions}
                search={true}
                onChange={sideIndex => {
                  this.props.editActions.setEdited({ ...editedIoBoard, side: sideIndex });
                }}
              />
              <NumberField
                id="index"
                label="Index"
                value={editedIoBoard.index}
                isError={!this.isFieldValid(ioBoardFields("index"))}
                onChange={val => this.props.editActions.setEdited({ ...editedIoBoard, index: val })}
              />
            </div>
          </Editor>
        )}
      </>
    );
  }

  private isFieldValid = (field: string): boolean => {
    const { editedIoBoard } = this.props;
    switch (field) {
      case ioBoardFields("index"):
        return editedIoBoard.index >= 0;
      case ioBoardFields("parallelIdx"):
        return editedIoBoard.parallelIdx >= 0;
      case ioBoardFields("configId"):
        return editedIoBoard.standard.id !== "";

      default:
        return true;
    }
  };

  private isAllFieldsValid = (): boolean => {
    const { editedIoBoard } = this.props;
    const temp = _.keys(editedIoBoard);
    for (const key of temp) {
      if (!this.isFieldValid(key)) {
        return false;
      }
    }
    return true;
  };
}

const mapStateToProps = (state: State.Root) => ({
  editedIoBoard: state.editView.editedObject,
  storedIoBoard: state.editView.storedObject,
  editedObjectId: editedObjectIdSelector(state.editView),
  pdApi: state.pdApi,
  ioConfig: state.ioConfig,
  columns: state.columns,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditIoBoard);


